const genders = [
   { value: 'FEMALE', name: 'Femenino' },
   { value: 'MALE', name: 'Masculino' },
   { value: 'NON_BINARY', name: 'No Binario' }
];

export default genders;
